/** Guardia de rutas: exige sesión, cuenta activa y, opcionalmente, ser admin. */

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export function Protegido({
  children,
  requiere,
}: {
  children: ReactNode;
  requiere?: 'gestor' | 'creador' | 'admin';
}) {
  const { usuario, perfil, esAdmin, cargando } = useAuth();
  if (cargando) return <div className="cargando">Cargando…</div>;
  if (!usuario) return <Navigate to="/login" replace />;

  if (perfil && perfil.activo === false) {
    return (
      <main className="pagina">
        <div className="aviso error">
          Su cuenta está deshabilitada. Contacte al administrador del sistema.
        </div>
      </main>
    );
  }

  // gestor/creador: cualquier usuario corporativo autenticado. admin: solo admins.
  const ok = !requiere || requiere !== 'admin' || esAdmin;

  if (!ok) {
    return (
      <main className="pagina">
        <div className="aviso error">
          No tiene permisos para acceder a esta sección. Contacte al administrador.
        </div>
      </main>
    );
  }
  return <>{children}</>;
}
